import { useEffect, useState } from "react";
import { useUiStore } from "../state/uiStore";
import { useUpdateActivityNote } from "../hooks/useActivities";
import { Sheet } from "../components/Sheet";

// Seule la note est éditable après coup : le backend ignore context_refs sur
// PATCH /activities/{id}/note, les liens se choisissent à la capture.
export function EditActivityNoteSheet() {
  const noteEditTarget = useUiStore((s) => s.noteEditTarget);
  const closeNoteEdit = useUiStore((s) => s.closeNoteEdit);
  const pushToast = useUiStore((s) => s.pushToast);
  const updateNote = useUpdateActivityNote();

  const [draft, setDraft] = useState(noteEditTarget?.current ?? "");

  useEffect(() => {
    setDraft(noteEditTarget?.current ?? "");
  }, [noteEditTarget]);

  if (!noteEditTarget) return null;

  async function handleSave() {
    if (!noteEditTarget) return;
    try {
      await updateNote.mutateAsync({
        startEventId: noteEditTarget.eventId,
        note: draft.trim(),
      });
      pushToast({ variant: "info", title: "Note enregistrée" });
      closeNoteEdit();
    } catch {
      pushToast({
        variant: "error",
        title: "Erreur",
        subtitle: "Impossible d'enregistrer la note.",
      });
    }
  }

  return (
    <Sheet
      title="Modifier la note"
      onClose={closeNoteEdit}
      footer={
        <div className="sheet-cta">
          <button
            className="primary"
            disabled={updateNote.isPending}
            onClick={() => void handleSave()}
          >
            Enregistrer
          </button>
        </div>
      }
    >
      <div style={{ fontSize: 12, color: "var(--fg3)", marginBottom: 8 }}>
        {noteEditTarget.label}
      </div>
      <input
        className="field"
        placeholder="Note de l'activité"
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        maxLength={200}
        autoFocus
      />
    </Sheet>
  );
}
